import Filter from './Filter'

class SelectBoxFilter extends Filter {
    select: JQuery

    constructor(filterView: JQuery) {
        super()

        const initialValue = filterView.data('initial-value') || []
        this.value = initialValue

        this.type = 'one'

        this.select = filterView.find('select')

        if (initialValue.length) this.select.val(initialValue[0])

        this.select.on('change', () => {
            const value = this.select.val()
            if (!value) {
                this.value = []
                this.select.addClass('empty')
            } else {
                this.value = [value as string]
                this.select.removeClass('empty')
            }
            this.onFilterChange()
        })
    }

    reset() {
        super.reset()
        this.select.val('')
        this.select.addClass('empty')
    }
}

export default SelectBoxFilter
